module.exports = __webpack_public_path__ + "static/img/onozuka_05.2ea1527.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/onozuka_05.jpg
// module id = metK
// module chunks = 0